/**
 * Created by baird on 2017/6/22.
 */
import * as types from '../mutation';

const state = {
    isUpdataProList: false, /*是否更新项目列表*/
    isUpdataDiyFormList: false /*是否更新表单列表*/
};
const actions = {};
const mutations = {
    [types.PAGE_UPDATA_STATE](state, res) {
        state = Object.assign(state, res);
    },
    [types.DIYFORM_UPDATA_STATE](state, res) {
        state = Object.assign(state, res);
    }
};
const getters = {
    isUpdataProList() {
        return state.isUpdataProList;
    }
};
export default {
    actions,
    mutations,
    getters,
    state
};



// WEBPACK FOOTER //
// ./src/store/modules/pagestate.js